import React,{ useContext, useEffect, useState } from "react";
import dayjs from '../utils/dayjs-setup';
import { AxiosInstance, CreditosTipo, DateFormatString, DialogType, FormActions, FormatPrice, TiposEntregaCheck } from "../utils/constants";
import {  AutoCompleteInputWithLabel, DatePickerInputWithLabel, InputWithLabel, SelectInputWithLabel } from "../components/form/custom-imputs";
import  * as yup from "yup";
import { ActionTypes, AppContext } from "../store/AppStore";
import { CalculateBodyRequestCheckout, ConverProductoValues, useCalculatePedido } from "./useCalculatePedido";
import { Card, CardContent, GridLegacy as Grid, IconButton, Stack, Typography } from '@mui/material';
import { Delete } from "@mui/icons-material";
import { ButtomQantity } from "../components/form/ButtomQantity";
import { InputFulterProduct } from "../components/form/InputAddProducto";


const FooterElementModal = ({
  config_client={}
})=>{
  const {total_valor_pedido,valor_pedido,costo_servicio,total_descuento,itemsByCentrosOpe,setconfigClient} = useCalculatePedido();
 
  useEffect(()=>{
   
    setconfigClient(config_client);
     

  },[config_client.items_added,config_client.typeService,config_client.tipo_pedido,config_client.tipo_pedido,config_client.medio_pago,config_client.centro_operacion]);

  return (
    <Grid container spacing={1} >
        <Grid item sm={6} md={6} xs={6} textAlign={"end"} >
          <Typography variant="subtitle1" ><strong>SUBTOTAL</strong></Typography>
          
        </Grid>
        <Grid item sm={6} md={6} xs={6} >
          <Typography variant="subtitle1" >$ {FormatPrice(valor_pedido)} COP</Typography>
          
        </Grid>
        <Grid item sm={6} md={6} xs={6} textAlign={"end"} >
          <Typography variant="subtitle1" ><strong>SERVICIO</strong></Typography>
          
        </Grid>
        <Grid item sm={6} md={6} xs={6} >
          <Typography variant="subtitle1" >$ {FormatPrice(costo_servicio)} COP</Typography>
        </Grid>
        <Grid item sm={6} md={6} xs={6} textAlign={"end"} >
          <Typography variant="subtitle1" ><strong>DESCUENTO</strong></Typography>
        </Grid>
        <Grid item sm={6} md={6} xs={6} >
          <Typography variant="subtitle1" >$ {FormatPrice(total_descuento)} COP</Typography>
        </Grid>
        
        <Grid item sm={6} md={6} xs={6}  textAlign={"end"} >
          <Typography variant="subtitle1" ><strong>TOTAL</strong></Typography>
        </Grid>
        <Grid item sm={6} md={6} xs={6} >
          <Typography variant="subtitle1" >$ {FormatPrice( total_valor_pedido,0 )} COP</Typography>
          
        </Grid>
    </Grid>
  )
}

const ProductListItem  = ({
  onDeleteIcon,
  producto,
  cantidad,
  configCliente,
  fieldForm,
  item_index,
  callFuncionOnChange = ()=>{},
  otherprops
})=>{


  const newProducto = {...producto,cantidad};
  const defProduct = ConverProductoValues(newProducto,configCliente);
  const observaciones = fieldForm.value[item_index]?.["observaciones"];

  const onChangeQantityProd = (newValue,key='cantidad')=>{
    let newData = [...fieldForm.value];
    newData[item_index][key] = newValue;
    fieldForm.onChange(newData);
    callFuncionOnChange(fieldForm.value);
  }


  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={12} md={12} >
          <Typography variant="p" ><strong>{producto.cod_erp_producto} - {producto?.label}</strong></Typography> 
        </Grid>
        <Grid container item sx={12} md={12} >
      
            <Grid item sx={6} md={6} sm={6} >
              <Typography><strong>PV BASE:</strong> $ { FormatPrice(defProduct.precio_venta,0)} COP</Typography>
            </Grid>
          
            <Grid item sx={6} md={6} sm={6} >
              <Typography><strong>DESC:</strong> $ { FormatPrice(defProduct.discount,0)} COP</Typography>
            </Grid>
            <Grid item sx={6} md={6} sm={6} >
              <Typography><strong>PV FINAL:</strong> $ { FormatPrice(defProduct.precio_venta_final,0)} COP</Typography>
            </Grid>
            <Grid item sx={12} md={12} sm={12} >
            <Stack direction={"row"} >
              <Typography><strong>Cantidad:</strong></Typography>
                <ButtomQantity 
                 prod_nombre={producto.cod_erp_producto+'-'+producto?.label}
                onDelete={onDeleteIcon}
                 observaciones={observaciones}
                  onChange={onChangeQantityProd }
                  maxQantity={producto.total_disponible_inv}  
                  value={Number(cantidad)}   />
            </Stack>
           
         
            </Grid>
            <Grid item sx={6} md={6} sm={6} >
              <Typography><strong>Subtotal:</strong> $ {FormatPrice(defProduct.subtotal_price,0)} COP</Typography>
            </Grid>
            <Grid item sx={6} md={6} sm={6} >
              <Typography><strong>TOTAL:</strong> $ {FormatPrice(defProduct.total_price,0)} COP</Typography>
            </Grid>
            {
              observaciones &&  <Grid item sx={12} md={12} sm={12} >
              <Typography><strong>Observaciones:</strong> {observaciones}</Typography>
            </Grid>
            }
           
          
           
        </Grid>
{/*         <Grid item sx={2} md={2} >
            <IconButton onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid> */}
      </Grid>
        
    </CardContent>
  </Card>)

}


const schemaProduct = yup.object({
  producto: yup.object().required(),
  cantidad:yup.number().min(1).required()
 
}).required();

const schemaDescargarPedidos = yup.object({
  centro_operacion: yup.object().required(),
  fecha_entrega:yup.string().required()
 
}).required();


const schemaPedidos = yup.object({
  tipo_pedido:yup.string().required(),
  cliente: yup.object().required(),
  sucursal_proveedor: yup.string().required(),
  tipo_entrega: yup.string().required(),
  medio_pago: yup.string().required(),
  tipo_credito:yup.string().notRequired().nullable(),
  fecha_entrega: yup.string().required(),
  productos_list:yup.array().min(1).required(),
  centro_operacion:yup.string().required(),
  persona_contacto:yup.string().optional().nullable().notRequired(),
}).required();


const InitialConfigClient = {
  sucursales:[],
  mediosPagos:[],
  selectedDir:null,
  representantes:[],
  items_added:[],
  typeService:null,
  credito:0,
  tipo_pedido:"",
  medio_pago:"",
  cod_cliente:null,
  centro_operacion:null
};


export const useCreationPedido = ({callbackOnCreate=()=>{},maestrosCompartidos,defaultEntity,tipoAction})=>{

    const {dispatch,store:{profile}} = useContext( AppContext );
    const [momentItem,setMomentItem] = useState({});
    const [productosOptions,setProductosOptions] = useState([]);
    const [clienteFiltro,setClienteFiltro] = useState([]);
    const {runCalculateRequest} = useCalculatePedido();
    const [tipos_entregas,setTiposEntregas] = useState([]);

    const [configCliente,setConfigCliente] = useState({...InitialConfigClient});
    const configuracionApp = profile.configuracion_comp?JSON.parse(profile.configuracion_comp):{};
    const sucursalSeleccionada = configCliente.sucursales.find(suc=>suc.value == configCliente.selectedDir);

    useEffect(()=>{

      if ( tipoAction === FormActions.MODIFICAR && defaultEntity.cliente  ){
   
/*         setConfigCliente({
          ...configCliente,
          items_added:defaultEntity.productos_list
        });  */
        onSearchSucursalesClientes(defaultEntity.cliente,undefined,{
          items_added:defaultEntity.productos_list,
          
          medio_pago:defaultEntity.medio_pago
        });
        
      }
     
    },[defaultEntity]);


    useEffect(()=>{
      return ()=>{
        console.log("on reset form");
        setConfigCliente({...InitialConfigClient});
        setProductosOptions([]);
      }
    },[]);
  
    const OnResetConfigEnv = ()=>{
      setConfigCliente(InitialConfigClient);
    }
    

    const tiposEntregasList = async (centro_operacion,dir_selected)=>{
      const  {data:{value:tipos_entregas}} = await AxiosInstance.post("maestros-marketplace/get-tipos-entregas-by-centro-op",{
        cod_centro_operacion:centro_operacion.value,
        cod_municipio:dir_selected.cod_municipio,
        cod_barrio:dir_selected.barrio,
       
      });

      if ( tipos_entregas.length === 0 ){

        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Advertencia",
              message:"La direccion seleccionada no tiene cobertura o servicios configurados para ese centro de operacion",
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }

      return tipos_entregas;
    }


    const onSelectDirDispatch = async(dir_selected) =>{

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });

      console.log({dir_selected});
      const  {data:{value:centro_operacion}} = await AxiosInstance.post("maestros-marketplace/get-centro-operacion-by-punto-entrega",{
        cod_punto_entrega:dir_selected.value,
       
      });
      console.log({dir_selected,centro_operacion});
     let tipos_entregas = null;

     if ( centro_operacion){
      tipos_entregas = await tiposEntregasList(centro_operacion,dir_selected)
     }

      

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });

  
      return {
        centro_operacion,
        tipos_entregas
      }


  
    }
  





   const onSearchCliente = (event, newInputValue)=>{
        
    if ( newInputValue && newInputValue.length > 2 && newInputValue.length % 2 === 0){
        AxiosInstance.post(`maestros-marketplace/get-clientes-filtro/${profile.cod_cia || ''}`,{
          text_search:newInputValue,
          is_taking_pedido:true
        }).then(({data})=>{
          setClienteFiltro(data.value);
        }).catch(err=>{
         // setClienteFiltro([]);
        }).finally(()=>{

        });
    }

}

const onSearchOfertaCliente = (evt,newValue)=>{
  console.log({evt,newValue});
  console.log({configCliente});
  if ( newValue && newValue.length > 0 && configCliente.centro_operacion ){
    dispatch({
      type:ActionTypes.setLoadingPage,
      data:true
    });
    AxiosInstance.post(`maestros-marketplace/filtrar-ofertas-cliente/${profile.cod_cia || ''}`,{
      search_text:newValue,
      cod_centro_operacion:configCliente.centro_operacion,
      cod_cliente:configCliente.cod_cliente,
      is_comercial:false
    }).then( ({data})=>{
      setProductosOptions(data.value);
    } ).catch(err=>{

    }).finally(()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    });
  }
 

}

const onSearchSucursalesClientes = (cliente,formProps,extraInfo ={})=>{

  if (!cliente){
    setConfigCliente({
      ...InitialConfigClient
    });
    return;
  }
  dispatch({
    type:ActionTypes.setLoadingPage,
    data:true
  });
        AxiosInstance.post("maestros-marketplace/obtener-config-cliente",{
          cod_cliente:cliente.value
        }).then( async({data})=>{
          if ( data.status ){
            const availableSucursal = data.value.sucursales.filter( item=>item.cod_municipio && item.barrio );
            if (configuracionApp.CREACION_PEDIDOS?.autoComplete){
              
             if ( formProps ){
                formProps.setValue("persona_contacto",String(data.value.representantes[0]?.value) || '');
                formProps.setValue("sucursal_proveedor",String( availableSucursal[0]?.value ) || '');
                formProps.setValue("medio_pago",String( configuracionApp.CREACION_PEDIDOS?.medio_pago ) || ''); 
                formProps.setValue("tipo_entrega",String( configuracionApp.CREACION_PEDIDOS?.tipo_entrega ) || '');
             }  
      
            const dirConfig = await onSelectDirDispatch(availableSucursal[0]);

             
              setTiposEntregas(dirConfig.tipos_entregas || []);
              if ( formProps ){
                formProps.setValue("centro_operacion",dirConfig.centro_operacion?.value || null);
              }
              let typeService = null;

              if ( tipoAction === FormActions.MODIFICAR ){
                typeService =  dirConfig.tipos_entregas?.find( item=>item.value === defaultEntity.tipo_entrega);
              }else{
                typeService =  dirConfig.tipos_entregas?.find( item=>item.value === configuracionApp.CREACION_PEDIDOS?.tipo_entrega);
                
              }
            
 
              
                setConfigCliente({
                ...configCliente,
                sucursales:availableSucursal,
                ...data?.value,
                cod_cliente:cliente?.value,
                medio_pago:configuracionApp.CREACION_PEDIDOS?.medio_pago,
                selectedDir:String( availableSucursal[0]?.value ),
                centro_operacion:dirConfig.centro_operacion?.value,
                typeService,
              ...extraInfo
              });
        
            }

          }else{

            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Error",
                  message:data.msg,
                  type:DialogType.peligro,
                  isVisible:true
              }
          });

          } 


        } ).catch(err=>{
          console.log(err.message);
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });

        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });

        
        });
}

const onsetSelectedDir = async(dir,fieldform)=>{

  const selectedDir = configCliente.sucursales.find(suc=>suc.value == dir);
  if ( selectedDir.cod_municipio && selectedDir.barrio ){
    const dirConfig =   await onSelectDirDispatch(selectedDir);

    fieldform.setValue("centro_operacion",dirConfig.centro_operacion.value);
   setConfigCliente({
      ...configCliente,
      selectedDir:dir,
      centro_operacion:dirConfig.centro_operacion.value,
    
    });
   
    setTiposEntregas(dirConfig.tipos_entregas);
   
 
  }else{
    dispatch({
      type:ActionTypes.setModalInfo,
      data:{
          title:"Direccion no valida",
          message:"La direccion que seleccionaste no esta correctamente configurada "+selectedDir.cod,
          type:DialogType.peligro,
          isVisible:true
      }
  });
  return;
  }

}
const onSaveDataFormPedidos = async(typeAction,dataForm)=>{

   
  dataForm.medio_pago = maestrosCompartidos.medios_pagos.find( md_item=>md_item.value == dataForm.medio_pago   );

  if ( dataForm.medio_pago.descripcion_corta === 'CR' ){
      if ( !dataForm.tipo_credito ){
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Tipo de credito no valido",
              message:"El tipo de credito es requerido",
              type:DialogType.peligro,
              isVisible:true
          }
      });
      return
      }
  }

  const fecha_servicio = {
    "ED":dayjs(dataForm.fecha_entrega).format(DateFormatString),
    "EE":dayjs(dataForm.fecha_entrega).format(DateFormatString),
    "RT":dayjs(dataForm.fecha_recogida).format(DateFormatString)
  }

    
   
    const {itemsByCentrosOpe,total_valor_pedido}  = runCalculateRequest(configCliente);
   // console.log({itemsByCentrosOpe,prod_list:dataForm.productos_list});
    const sucursal = configCliente.sucursales.find( sucursal=>sucursal.cod == dataForm.sucursal_proveedor );
    const paydloadList = CalculateBodyRequestCheckout(itemsByCentrosOpe,sucursal,fecha_servicio,dataForm,total_valor_pedido,tipos_entregas,configCliente);

   //console.log({paydloadList,itemsByCentrosOpe,sucursal,fecha_servicio,dataForm,total_valor_pedido,tipos_entregas});
  
    dispatch({
      type:ActionTypes.setLoadingPage,
      data:true
    });
    AxiosInstance.post(`maestros-marketplace/${FormActions.AGREGAR === tipoAction?'registrar-pedido':'editar-pedido'}`,{
      pedidos:paydloadList
    }).then( ({data})=>{
    
      if (data.status){
        callbackOnCreate();
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title: FormActions.AGREGAR === tipoAction? "Registro exitoso": 'Pedido editado exitosamente',
              message:data.msg,
              type:DialogType.exitoso,
              isVisible:true
          }
      });
      }else{
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Error al tratar de registrar el pedido",
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }
     

    } ).catch(error=>{

      dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            title:"Error",
            message:"Error de comunicacion verifique su conexion a internet",
            type:DialogType.peligro,
            isVisible:true
        }
    });

    }).finally(()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    });
          
    return;
};
  
   const configCreationPedido =  {
    schemaValidator:schemaPedidos,
    typeAction:tipoAction,
    titleModal: "PEDIDOS",
    entityValues:defaultEntity,
    onSendForm:onSaveDataFormPedidos,
    buttomsAction:[
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }
    ],
    imputs:[
      {
        key:"tipo_pedido",
        keyValue:"tipo_pedido",
        label:"Tipo de pedido",
        component:SelectInputWithLabel,
        callFuncionOnChange:(value)=>{
          
          setConfigCliente({
            ...configCliente,
            tipo_pedido:value
          });
        },
        responsiveSize:6,
        inputProps:{
          disabled:tipoAction === FormActions.MODIFICAR,
          type:"text",
          size:"small",
          items:[
            {
              label:"PEDIDO",
              value:"PEDIDO"
            },
            {
              label:"COTIZACION",
              value:"COTIZACION"
            },
            /* {
              label:"SOLICITUD",
              value:"SOLICITUD"
            } */
          ]
          
        }
      },
      {
        key:"cliente",
        keyValue:"cliente",
        label:"Cliente",
        responsiveSize:12,
        callFuncionOnChange:onSearchSucursalesClientes,
        component: AutoCompleteInputWithLabel,
            inputProps: {
              disabled:tipoAction === FormActions.MODIFICAR,
              size:"small",
              typeInput:"autoComplete",
             name:'cliente',
              fullWidth: true,
              isLoading: false,
              //callFuncionOnChange:onSearchSucursalesClientes,
              onInputChange: onSearchCliente,
              options: clienteFiltro || [],
              noOptionsText: "Lista vacia",
              getOptionLabel: (option) => option.label,
              isOptionEqualToValue: (option, value) => option.value === value.value,
              filterOptions:(x) => x,
            }
      },
      {
        key:"persona_contacto",
        keyValue:"persona_contacto",
        label:"Persona de contacto",
        //callFuncionOnChange:onsetSelectedDir,
        component:SelectInputWithLabel,
        responsiveSize:12,
        inputProps:{
          disabled:tipoAction === FormActions.MODIFICAR,
          size:"small",
          type:"text",
          items:configCliente.representantes,
        }
      },
      {
        key:"sucursal_proveedor",
        keyValue:"sucursal_proveedor",
        label:"Punto de entrega o socursal",
        callFuncionOnChange:onsetSelectedDir,
        component:SelectInputWithLabel,
        responsiveSize:12,
        inputProps:{
          disabled:tipoAction === FormActions.MODIFICAR,
          size:"small",
          type:"text",
          items:configCliente.sucursales || [],
        }
      },
      {
        key:"centro_operacion",
        keyValue:"centro_operacion",
        label:"Centro de operacion",
        callFuncionOnChange:async(value,filedForm)=>{
    
          const centro_op = maestrosCompartidos.centros_operaciones.find(item=>item.value === value);
           if (value){
            
            const tipos_entregas = await tiposEntregasList({value:value},sucursalSeleccionada);
            setTiposEntregas(tipos_entregas);
           }
          
          setConfigCliente({
            ...configCliente,
            centro_operacion:value
          });
        },
        component:SelectInputWithLabel,
        responsiveSize:12,
        inputProps:{
          disabled:tipoAction === FormActions.MODIFICAR,
          size:"small",
          type:"text",
          items:maestrosCompartidos.centros_operaciones || [],
        }
      },
      {
        key:"tipo_entrega",
        keyValue:"tipo_entrega",
        label:"Tipo de entrega",
        component:SelectInputWithLabel,
        callFuncionOnChange:(value)=>{

          const servicio = tipos_entregas.find( item=>item.value === value);
           
          setConfigCliente({
            ...configCliente,
            typeService:servicio
          });
        },
        responsiveSize:6,
        inputProps:{
          disabled:tipoAction === FormActions.MODIFICAR,
          type:"text",
          size:"small",
          items:tipos_entregas,
          
        }
      },
      {
        key:"medio_pago",
        keyValue:"medio_pago",
        label:"Medio de pago",
        component:SelectInputWithLabel,
        callFuncionOnChange:(value)=>{

          const select = maestrosCompartidos.medios_pagos.find((item)=> item.value == value );
          
          setConfigCliente({
            ...configCliente,
            medio_pago:select
          });
        },
        responsiveSize:6,
        inputProps:{
          disabled:tipoAction === FormActions.MODIFICAR,
          type:"text",
          size:"small",
        items:configCliente.credito > 0? maestrosCompartidos.medios_pagos:maestrosCompartidos.medios_pagos.filter(item=>item.descripcion_corta !== 'CR'),
        }
      },
      {
        key:"tipo_credito",
        keyValue:"tipo_credito",
        label:"Tipo de credito",
        component:SelectInputWithLabel,
/*           callFuncionOnChange:(value)=>{
          const select = mediosPagos.find( item.value == value );
          setMedioPagoSeleccionado(select);
        }, */
        responsiveSize:6,
        inputProps:{
         disabled:!configCliente.medio_pago?true:configCliente.medio_pago.descripcion_corta !== 'CR'?true:false,
          type:"text",
          size:"small",
          items:configuracionApp.CREACION_PEDIDOS?.TIPO_CREDITO,
        }
      },
      {
        key:"fecha_entrega",
        keyValue:"fecha_entrega",
        label:"Fecha de entrega del pedido",
        component:DatePickerInputWithLabel,
        responsiveSize:6,
        inputProps:{
          type:"date",
          size:"small",
          minDate:configCliente.typeService?.value === 'ED'?dayjs().add(1,"days"):dayjs().startOf("day"),
          maxDate:configCliente.typeService?.value === 'ED'?dayjs().add(3,"days"):dayjs().add(3,"days").startOf("day")
         }
      },
     ],
    arrayInputs:[
      {
        label:"Items del pedido",
        key:"productos_list",
        keyValue:"productos_list",
        key_item:"producto.cod_oferta",
        subSchema:schemaProduct,
        type_vew:"modal",
        CustomModal:InputFulterProduct,
        customModalProps:{
          onInputChange: onSearchOfertaCliente,
          options: productosOptions || [],
          configCliente
        },
        callFuncionOnChange:(items)=>{
         
          if ( !items ){
            return;
          }
       
         setMomentItem({});
          setConfigCliente({
            ...configCliente,
            items_added:items
          }); 
        },
        ItemRender:props=><ProductListItem {...props} configCliente={configCliente} />,
        inputs:[
          {
            key:"producto",
            keyValue:"producto",
            label:"Producto",
            responsiveSize:8,
            callFuncionOnChange:(value)=>setMomentItem(value),
            component: AutoCompleteInputWithLabel,
                inputProps: {
                  size:"small",
                  typeInput:"autoComplete",
                 name:'cliente',
                  fullWidth: true,
                  isLoading: false,
                  //callFuncionOnChange:onSearchSucursalesClientes,
                  onInputChange: onSearchOfertaCliente,
                  options: productosOptions || [],
                  noOptionsText: "Lista vacia",
                  getOptionLabel: (option) => option.label,
                  isOptionEqualToValue: (option, value) => option.value === value.value,
                  filterOptions:(x) => x,
                }
          },
          {
            key:"cantidad",
            keyValue:"cantidad",
            label:"Cantidad",
            responsiveSize:4,
            component:InputWithLabel,
            inputProps:{
              type:"number",
              size:"small",
              customHelper:`UND Disp: ${momentItem?.total_disponible_inv || 0}`,
            }
          },
          
        ]
      },
    ],
    FooterElement:()=><FooterElementModal config_client={configCliente}  />
  };

    return {
      configCreationPedido,
      OnResetConfigEnv
    }
}